import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'

// 1. iframe 类型的页面 根据 菜单名称寻找 顶级菜单 和 应该被高亮的菜单 ID
export const findTopMenuIframe = (list, linkUrl, topPath) => {
  for (let i = 0; i < list.length; i++) {
    if (window.topMenuPath) break
    if (list[i].children && list[i].children.length) {
      findTopMenuIframe(list[i].children, linkUrl, topPath || list[i].path)
    } else {
      if (+list[i].viewType === 2 && linkUrl === list[i].linkUrl) {
        window.topMenuPath = topPath // 当前iframe 嵌入页面属于哪个模块
        window.activeMenuId = list[i].id // 当前 应该被高亮的菜单 id
        window.activeMenuParentId = list[i].pid // 当前 应该被高亮的菜单 父级菜单 id
      }
    }
  }
}

// 2. 寻找激活状态的 路径链 (左侧菜单 叶子节点高亮、父节点定位)
export const findActivePathChain = (path, list) => {
  if (window.activeMenuParentId) {
    // iframe 类型
    const findMenuById = (id, tempList) => {
      tempList.forEach((item) => {
        if (item.id === id) {
          window.activeMenuChain.unshift(id)
          if (item.pid) {
            findMenuById(item.pid, tempList)
          }
        } else {
          if (item.children && item.children.length) {
            findMenuById(id, item.children)
          }
        }
      })
    }
    findMenuById(window.activeMenuParentId, list)
  } else {
    list.forEach((item) => {
      const pathReg = new RegExp('^' + item.path)
      if (pathReg.test(path)) {
        if (item.path) {
          window.activeMenuChain.push(item.path)
        }
        if (item.children && item.children.length) {
          findActivePathChain(path, item.children)
        }
      }
    })
  }
}

// 3. 获取当前路由 对应的顶级菜单
export const findTopMenu = ($route, list) => {
  window.topMenuPath = ''
  window.activeMenuId = ''
  window.activeMenuParentId = null
  window.activeMenuChain = []
  if ($route && $route.path) {
    if (/^\/iframe/.test($route.path)) {
      // iframe 类型页面
      if ($route.params) {
        findTopMenuIframe(list, decodeURIComponent($route.query.linkUrl || ''))
      }
    } else {
      // 系统路由页面
      if (/^\/upload\//.test($route.path)) {
        window.topMenuPath = '/upload'
      } else if (/^\/feedback\//.test($route.path)) {
        window.topMenuPath = '/feedback'
      } else {
        for (let i = 0; i < list.length; i++) {
          const reg = new RegExp('^' + list[i].path)
          if (reg.test($route.path)) {
            window.topMenuPath = list[i].path
          }
        }
      }
    }
  }
}

// 4. 判断同一浏览器多个窗口 是否是同一个登录用户(针对 多个窗口 通过登录页 登录系统的情况 以最后登录的用户为当前浏览器登录造价云的用户 )
export const isSameUser = () => {
  const userInfoInCookie = getCookie('ZJYUSERINFO')
  const userInfoInWindow = window.ZJYUSERINFO
  let sameUser = true
  if (userInfoInWindow && userInfoInCookie) {
    try {
      if (JSON.parse(userInfoInWindow).gldUserId !== JSON.parse(userInfoInCookie).gldUserId) {
        window.ZJYUSERINFO = ''
        sameUser = false
      }
    } catch (e) {
      console.log(e)
    }
  }
  return sameUser
}

/* 5. 根据cookie中是否包含某个权限id 判断某个云产品是否 有权限
      针对从P6 跳转到 造价云管理平台  若 cookie里面DOGNUM的值 包含 13071、13072 那么代表企业数据库 下 计价依据库 有查看权限
 */
export const judgeApplicationPermissionByCookie = (obj, params) => {
  let dic = {
    // 计价依据库 权限ID 为15
    15: ['13071', '13072']
  }
  if (params) {
    dic = params
  }
  console.log(dic)
  const tempObj = obj || {}
  for (const key in dic) {
    if (!tempObj[key]) {
      const str = getCookie('DOGNUM') || ''
      const arr = str.split(',')
      arr.forEach((val) => {
        if (dic[key].includes(val)) {
          tempObj[key] = true
        }
      })
    }
  }
  console.log(tempObj)
  return tempObj
}

// 获取cookie、
export const getCookie = (name) => {
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  const arr = document.cookie.match(reg)
  if (arr && arr.length > 2) { return decodeURIComponent(arr[2]) } else { return null }
}

// 设置cookie,增加到vue实例方便全局调用
export const setCookie = (cName, value, expiredays) => {
  let exdate = new Date()
  exdate.setDate(exdate.getDate() + expiredays)
  let domain = ''
  if (window.location.host.indexOf('glodon.com') > -1){
    domain = 'domain=glodon.com;'
  }
  document.cookie = cName + '=' + escape(value) + ((expiredays === null) ? '' : ';expires=' + exdate.toGMTString()) + ';' + domain + 'path=/'
}

// 删除cookie
export const delCookie = (name) => {
  let exp = new Date()
  exp.setTime(exp.getTime() - 1)
  let domain = ''
  try {
    if (window.location.host.indexOf('glodon.com') > -1){
      domain = ';domain=glodon.com'
    }
  } catch (error){}
  let cval = getCookie(name)
  if (cval !== null) { document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + exp.toGMTString() + domain }
}

export const promisify = (fn, receiver) => {
  return () => {
    let args = []
    for (let _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }

    return new Promise((resolve, reject) => {
      fn.apply(receiver, [].concat(args, [(err, res) => {
        return err ? reject(err) : resolve(res)
      }]))
    })
  }
}

export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return
  let i = -1
  let len = arr.length
  while (++i < len) {
    let item = arr[i]
    fn(item, i, arr)
  }
}

export const getCommonString = (arr1, arr2) => {
  let len = Math.min(arr1.length, arr2.length)
  let i = -1
  let res = []
  while (++i < len) {
    const item = arr2[i]
    if (arr1.indexOf() > -1) res.push(item)
  }
  return res
}

/**
 * @param {Array} arr1
 * @param {Array} arr2
 * @description 得到两个数组的交集, 两个数组的元素为数值或字符串
 */
export const getIntersection = (arr1, arr2) => {
  return Array.from(new Set([...arr1, ...arr2]))
}

/**
 * @param {Array} target 目标数组
 * @param {Array} arr 需要查询的数组
 * @description 判断要查询的数组是否至少有一个元素包含在目标数组中
 */
export const oneOf = (target, arr) => {
  return target.some(_ => arr.indexOf(_) > -1)
}

/**
 * @param {Number} timeStamp 判断时间戳格式是否是毫秒
 * @returns {Boolean}
 */
const isMillisecond = timeStamp => {
  const timeStr = String(timeStamp)
  return timeStr.length > 10
}

/**
 * 判断一个对象是否为空
 *
 * @param e {}
 *            对象
 * @returns {Number} true 为空
 */
export const isEmptyObject = e => {
  let t
  for (t in e) { return !1 }
  return !0
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} currentTime 当前时间时间戳
 * @returns {Boolean} 传入的时间戳是否早于当前时间戳
 */
const isEarly = (timeStamp, currentTime) => {
  return timeStamp < currentTime
}

/**
 * @param {Number} num 数值
 * @returns {String} 处理后的字符串
 * @description 如果传入的数值小于10，即位数只有1位，则在前面补充0
 */
export const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

/**
 * @param {Number} timeStamp 传入的时间戳
 * @param {Number} startType 要返回的时间字符串的格式类型，传入'year'则返回年开头的完整时间
 */
export const getDate = (timeStamp, startType = 'year') => {
  const d = new Date(timeStamp * 1000)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (startType === 'year') resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
  else resStr = month + '-' + date + ' ' + hours + ':' + minutes
  return resStr
}

/**
 * @param {String|Number} timeStamp 时间戳
 * @returns {String} 相对时间字符串
 */
export const getRelativeTime = timeStamp => {
  // 判断当前传入的时间戳是秒格式还是毫秒
  const IS_MILLISECOND = isMillisecond(timeStamp)
  // 如果是毫秒格式则转为秒格式
  if (IS_MILLISECOND) Math.floor(timeStamp /= 1000)
  // 传入的时间戳可以是数值或字符串类型，这里统一转为数值类型
  timeStamp = Number(timeStamp)
  // 获取当前时间时间戳
  const currentTime = Math.floor(Date.parse(new Date()) / 1000)
  // 判断传入时间戳是否早于当前时间戳
  const IS_EARLY = isEarly(timeStamp, currentTime)
  // 获取两个时间戳差值
  let diff = currentTime - timeStamp
  // 如果IS_EARLY为false则差值取反
  if (!IS_EARLY) diff = -diff
  let resStr = ''
  const dirStr = IS_EARLY ? '前' : '后'
  // 少于等于59秒
  if (diff <= 59) resStr = diff + '秒' + dirStr
  // 多于59秒，少于等于59分钟59秒
  else if (diff > 59 && diff <= 3599) resStr = Math.floor(diff / 60) + '分钟' + dirStr
  // 多于59分钟59秒，少于等于23小时59分钟59秒
  else if (diff > 3599 && diff <= 86399) resStr = Math.floor(diff / 3600) + '小时' + dirStr
  // 多于23小时59分钟59秒，少于等于29天59分钟59秒
  else if (diff > 86399 && diff <= 2623859) resStr = Math.floor(diff / 86400) + '天' + dirStr
  // 多于29天59分钟59秒，少于364天23小时59分钟59秒，且传入的时间戳早于当前
  else if (diff > 2623859 && diff <= 31567859 && IS_EARLY) resStr = getDate(timeStamp)
  else resStr = getDate(timeStamp, 'year')
  return resStr
}


/**
 * @returns {String} 当前浏览器名称
 */
export const getExplorer = () => {
  const ua = window.navigator.userAgent
  const isExplorer = (exp) => {
    return ua.indexOf(exp) > -1
  }
  if (isExplorer('MSIE')) return 'IE'
  else if (isExplorer('Firefox')) return 'Firefox'
  else if (isExplorer('Chrome')) return 'Chrome'
  else if (isExplorer('Opera')) return 'Opera'
  else if (isExplorer('Safari')) return 'Safari'
}

/**
 * @description 绑定事件 on(element, event, handler)
 */
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/**
 * @description 解绑事件 off(element, event, handler)
 */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()


const stringifyPrimitive = function (v) {
  switch (typeOf(v)) {
    case 'String':
      return v

    case 'Boolean':
      return v ? 'true' : 'false'

    case 'Number':
      return isFinite(v) ? v : ''

    default:
      return ''
  }
}

export const queryEncode = (obj, sep, eq, name) => {
  sep = sep || '&'
  eq = eq || '='
  if (obj === null) {
    obj = undefined
  }

  if (typeOf(obj) === 'Object') {
    return Object.keys(obj).map(function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq
      if (Array.isArray(obj[k])) {
        return obj[k].map(function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v))
        }).join(sep)
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]))
      }
    }).join(sep)

  }

  if (!name) return ''
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
    encodeURIComponent(stringifyPrimitive(obj))
}

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
  let i = -1
  while (++i < times) {
    callback(i)
  }
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1] ? url.split('?')[1].split('&') : []
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}


/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeOf(time) === 'Object') {
    date = time
  } else {
    if ((typeOf(time) === 'String') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeOf(time) === 'Number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime (time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}
export function sizeConver (limit){
  let size = ''
  let unit = 'B'
  if (limit < 0.1 * 1024) { // 如果小于0.1KB转化成B
    size = limit.toFixed(2)
  } else if (limit < 1 * 1024 * 1024) { // 如果小于0.1MB转化成KB
    size = (limit / 1024).toFixed(2)
    unit = 'KB'
  } else if (limit < 1 * 1024 * 1024 * 1024) { // 如果小于0.1GB转化成MB
    size = (limit / (1024 * 1024)).toFixed(2)
    unit = 'MB'
  } else { // 其他转化成GB
    size = (limit / (1024 * 1024 * 1024)).toFixed(2)
    unit = 'GB'
  }
  let sizeStr = size + ''
  // 当小数点后为00时 去掉小数部分
  const arr = /\d+(\.00)$/.exec(sizeStr)
  if (arr && arr.length > 1) {
    sizeStr = sizeStr.substring(0, sizeStr.indexOf(arr[1]))
  }
  return sizeStr + unit
}

function formatNumber (n) {
  n = n.toString()
  return n[1] ? n : '0' + n
}
export function formatDay (date, format) {
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()

  let hour = date.getHours()
  let minute = date.getMinutes()
  // let second = date.getSeconds();

  if (format === 'H'){
    return `${[year, month, day].map(formatNumber).join('-')} ${[hour, minute].map(formatNumber).join(':')}`
  } else if (format === 'M'){
    return `${[year, month].map(formatNumber).join('-')}`
  } else if (format === 'D') {
    return `${[month, day].map(formatNumber).join('-')}`
  }
  return [year, month, day].map(formatNumber).join('-')

}

export function addZero (val) {
  return val * 1 < 10 ? '0' + val : val
}
// 将毫秒数转换成 时长
export function formatDuration (val, pfx, cfig) {
  const config = cfig || {}
  const second = 1000
  const minute = 60 * second
  const hour = 60 * minute
  const day = 24 * hour
  let prefix = pfx || ''
  if (/^\d+$/.test(val)) {
    let str = +val
    if (str < second) {
      if ((str > 0 || !prefix) && !config.noMillisecond) {
        str = str + (config.en ? 'ms' : '毫秒')
      } else {
        str = ''
      }
    } else if (str < minute) {
      let secondVal = addZero(Math.floor(str / second))
      if (config.decimalSecond && config.noMillisecond) {
        // 不显示毫秒 秒保留两位小数
        secondVal += '.' + addZero(Math.floor((str % second) / 1000 * 100))
      }
      const seconds = secondVal + (config.en ? 's' : '秒')
      prefix += seconds
      str = seconds + formatDuration(str % second, prefix, config)
    } else if (str < hour || config.max === 'minute') {
      const minutes = addZero(Math.floor(str / minute)) + (config.en ? 'm' : '分')
      prefix += minutes
      str = minutes + formatDuration(str % minute, prefix, config)
    } else if (str < day || config.max === 'hour') {
      const hours = addZero(Math.floor(str / hour)) + (config.en ? 'h' : '小时')
      prefix += hours
      str = hours + formatDuration(str % hour, prefix, config)
    } else {
      str = addZero(Math.floor(str / day)) + (config.en ? 'D ' : '天 ') + formatDuration(str % day, prefix, config)
    }
    return str
  } else {
    return val
  }
}

// 判断是否为整数
export function integer (val) {
  return (val !== void 0 && /^[-]?\d+$/.test(val))
}

// 使字符串(首字母)大写(或小写 reverse为true的时候; all为true的时候 全部转换成大写或小写)
export function capitalize (string, reverse, all){
  if (string !== undefined && typeOf(string) === 'String') {
    let str = string.charAt(0).toUpperCase()
    if (reverse) {
      str = string.charAt(0).toLowerCase()
    }
    str += string.slice(1)
    if (all) {
      const arr = string.split('')
      let s = ''
      arr.forEach((char) => {
        s += reverse ? char.toLowerCase() : char.toUpperCase()
      })
      return s
    }
    return str
  }
  return string
}

// UUID ( 生成一个随机不重复的字符串)
export function UUID () {
  var T = function () {
    let d = 1 * new Date()
    let i = 0
    while (d === 1 * new Date()) {
      i++
    }
    return d.toString(16) + i.toString(16)
  }
  var R = function () {
    return Math.random().toString(16).replace('.', '')
  }
  var UA = function (n) {
    let ua = navigator.userAgent
    let ch = 0
    let buffer = []
    let ret = 0

    function xor (result, byteArray) {
      let tmp = 0
      for (let j = 0; j < byteArray.length; j++) {
        tmp |= (buffer[j] << j * 8)
      }
      return result ^ tmp
    }

    for (let i = 0; i < ua.length; i++) {
      ch = ua.charCodeAt(i)
      buffer.unshift(ch & 0xFF)
      if (buffer.length >= 4) {
        ret = xor(ret, buffer)
        buffer = []
      }
    }

    if (buffer.length > 0) {
      ret = xor(ret, buffer)
    }

    return ret.toString(16)
  }
  var type = 1
  // 有些浏览器取个屏幕宽度都异常...
  var se = String(screen.height * screen.width)
  if (se && /\d{5,}/.test(se)) {
    se = se.toString(16)
  } else {
    se = String(Math.random() * 31242).replace('.', '').slice(0, 8)
  }
  var val = (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T())
  // if(val){
  //   just_test_distinctid_2 = 1;
  //   return val;
  // }else{
  //   just_test_distinctid_2 = 2;
  //   return (String(Math.random()) + String(Math.random()) + String(Math.random())).slice(2, 15);
  // }
  if (!val) {
    type = 2
    val = (String(Math.random()) + String(Math.random()) + String(Math.random())).slice(2, 15)
  }
  return {uuidType: type, uuidVal: val}
}

// 克隆
export function clone (obj) { // 克隆
  let reObj = {}
  const originalDataType = typeOf(obj)
  switch (originalDataType) {
    case 'Object':
      for (const key in obj) {
        reObj[key] = clone(obj[key])
      }
      break
    case 'Function':
      reObj = null
      break
    case 'Array':
      if (obj.length < 1) {
        reObj = []
      } else {
        reObj = []
        for (let i = 0; i < obj.length; i++) {
          reObj.push(clone(obj[i]))
        }
      }
      break
    default:
      reObj = obj
  }
  return reObj
}

/**
 * 2. 将数组中的全部元素 分堆（每num个构成一个小数组）
 *   @param  arr : 分堆前的数组（Array）
 *   @param  num : 每多少个 分一堆 (Number)
 *   @param  completion :是否补全 (Boolean)
 *   @param  defaultItem : 若补全 默认补全的数据
 *   @return reArr : 分堆后的数组（array）
 */
export function pilesArr (arr, num, completion, defaultItem){
  let reArr = []
  let pileNo = Math.ceil(arr.length / num)
  for (let i = 1; i <= pileNo; i++){
    let smallArr = []
    let maxJ = i * num
    if (!completion) {
      if (maxJ > arr.length) {
        maxJ = arr.length
      }
    }
    for (let j = (i - 1) * num; j < maxJ; j++){
      let item
      if (j > arr.length - 1) {
        if (defaultItem !== undefined) {
          item = defaultItem
        }
      } else {
        item = arr[j]
      }
      smallArr.push(item)
    }
    reArr.push(smallArr)
  }
  return reArr
}

// 将对象的值 以参数的方式拼接在url后面
export function processParams (url, params) {
  // 如果是字符串直接返回
  let data = []
  for (let k in params) {
    if (k !== 'needDecode') {
      let val = params[k] == null ? '' : params[k]
      if (params.needDecode && params.needDecode.split(',').includes(k)) {
        val = decodeURIComponent(val)
      }
      data.push(k + '=' + encodeURIComponent(val))
    }
  }
  let reStr = ''
  if (url.includes('?')){
    reStr = url + '&' + data.join('&')
  } else {
    reStr = url + '?' + data.join('&')
  }
  reStr.replace(/\?&/g, '?')
  reStr.replace(/(&&)/g, '&')
  return reStr
}

export function isIE () {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true } else { return false }
}

export function IEVersion () {
  var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
  var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
  var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
  if (isIE) {
    var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
    reIE.test(userAgent)
    var fIEVersion = parseFloat(RegExp['$1'])
    if (+fIEVersion === 7) {
      return 7
    } else if (+fIEVersion === 8) {
      return 8
    } else if (+fIEVersion === 9) {
      return 9
    } else if (+fIEVersion === 10) {
      return 10
    } else {
      return 6// IE版本<=7
    }
  } else if (isEdge) {
    return 'edge'// edge
  } else if (isIE11) {
    return 11 // IE11
  } else if (userAgent.indexOf('Opera') > -1){
    return 'Opera'
  } else if (userAgent.indexOf('Firefox') > -1){
    return 'Firefox'
  } else {
    return false// 不是ie浏览器
  }
}

export function addEvent (elm, evType, fn) {
  var typeArr = evType.split(' ')
  for (var i = 0; i < typeArr.length; i++){
    if (elm.addEventListener) {
      elm.addEventListener(typeArr[i], fn)// DOM2.0
    } else if (elm.attachEvent) {
      elm.attachEvent('on' + typeArr[i], fn)// IE5+
    } else {
      elm['on' + typeArr[i]] = fn// DOM 0
    }
  }
}
